import React, { useState, useEffect, useMemo } from 'react';
import { sortBy as sort, ceil, debounce, indexOf, isArray, trim } from 'lodash';
import { Spin, Tooltip, Popover, notification, Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { WarehouseWrapper } from './style';

import AgGrid from '../../components/ag-grid-table/index';
import ProductImg from '../../assets/images/newImages/nestle.svg';
import InventoryIcon from '../../assets/icons/inventry-icon-ad.svg';
import WarnIcon from '../../assets/icons/warning-modal-icon.svg';
import Pagination from '../../components/pagination/index';
import SearchInput from '../../components/uiComponent/inputs/searchinput/index';
import Modal from '../../components/uiComponent/modal/index';
import InventoryAdjustment from './inventory-adjustment';
import LocationHistory from './location-history';
import MoveLocation from './move-location';
import { GoUpload } from 'react-icons/go';
import XLSX from 'xlsx';

import Button from '../../components/uiComponent/button/index';

import { convertUtcToEst } from '../../utils/helpers';


import {
  GetLocationProducts
} from '../../slices/location-management';
import { PoDetailsWrapper } from '../purchase-order/po-details/style';
import { IoIosArrowDown } from 'react-icons/io';

let gridApi;
let gridColumnApi;

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isMoveToLocation, setIsMoveToLocation] = useState(false);
  const [locationHistory, setLocationHistory] = useState(false);
  const [deleteLocation, setDeleteLocation] = useState(false);
  const [showInventoryAdjustmentModal, setShowInventoryAdjustmentModal] = useState(false);
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [openExport, setOpenExport] = useState(false);
  const [zeroEntriesSwitch, setZeroEntriesSwitch] = useState(false);
  

  const { pageNumber, pageSize } = page || {};

  const {
    fetchingLocationProducts,
    totalLocationProductsCount,
    locationProducts,
    locationDetails
  } = useSelector((state) => state?.locationManagement || {});

  const params = new URLSearchParams(window.location.search);
  const locationId = params.get('id');

  useEffect(() => {
    if (locationId) {
      dispatch(GetLocationProducts({
        id: locationId,
        params: {
          page,
          filters,
          showZeroFlag: zeroEntriesSwitch
        }
      }));
    }
    else navigate('/warehouse-location');
  }, []);

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

    if (value && ['quantity', 'expiry_date', 'created_at', 'customer_name', 'name', 'brand', 'identifier_value', 'reserved_qty'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetLocationProducts({
        id: locationId,
        params: {
          page,
          filters,
          sortBy: { key: colId, type: sort },
          showZeroFlag: zeroEntriesSwitch
        }
      }));
    }
  };

  const gridReady = (params) => {
    gridApi = params.api;
    gridColumnApi = params.columnApi;
  };

  const columnDefinitions = useMemo(() => [
    {
      headerName: '',
      width: 75,
      field: 'seller_skus.length',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      cellRenderer: 'agGroupCellRenderer',
      suppressRowClickSelection: true
    },
    {
      headerName: 'Customer Name',
      field: 'customer_name',
      minWidth: 150,
      flex: 1,
      sortable: true,
      comparator : ()=> '',
      cellRenderer: ({ data }) => {
        const { first_name, email } = data?.products_v2?.user || {};

        return (
          <div className="customer-col-wrapper">
            <p>{first_name || '---'}</p>
            <span>{email || '---'}</span>
          </div>
        );
      }
    },
    {
      headerName: 'Title',
      field: 'name',
      minWidth: 160,
      width: 160,
      sortable: true,
      comparator : ()=> '',
      flex: 1,
      cellRenderer: ({ data }) => {
        const { image_url, name } = data?.products_v2 || {};

        return (
          <div className='card-wrapper'>
            <img src={image_url || ProductImg} alt="ProductImg" title="ProductImg" />
            <span className='two-line-ellipsis'>
              {name || '---'}
            </span>
          </div>
        );
      }
    },
    {
      headerName: 'Identifier',
      field: 'identifier_value',
      width: 125,
      minWidth: 125,
      flex: 1,
      sortable: true,
      comparator : ()=> '',
      cellRenderer: ({ data }) => {
        const { identifier_type, identifier_value } = data?.products_v2 || {};

        return (
          <div className="customer-col-wrapper">
            <p>{identifier_type || '---'}</p>
            <span>{identifier_value}</span>
          </div>
        );
      }
    },
    {
      headerName: 'Brand',
      field: 'brand',
      minWidth: 150,
      flex: 1,
      sortable: true,
      comparator : ()=> '',
      cellRenderer: ({ data }) => {
        const { brand = '' } = data?.products_v2 || {};

        return (
          <div className="customer-col-wrapper">
            <p>{brand || '---'}</p>
          </div>
        );
      }
    },
    {
      headerName: 'Quantity',
      minWidth: 95,
      flex: 1,
      field: 'quantity',
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value }) => value || 0
    },
    // {
    //   headerName: 'Reserved Quantity',
    //   minWidth: 130,
    //   field: 'reserved_qty',
    //   comparator: () => 0,
    //   flex: 1,
    //   sortable: true,
    //   cellRenderer: ({ value }) => value || 0
    // },
    {
      headerName: 'Expiry Date',
      minWidth: 130,
      field: 'expiry_date',
      comparator: () => '',
      flex: 1,
      sortable: true,
      cellRenderer: ({ value }) => value ? convertUtcToEst(value, { year: 'numeric', month: '2-digit', day: '2-digit' }) : '---'
    },
    {
      headerName: 'Date Added',
      minWidth: 130,
      flex: 1,
      comparator: () => '',
      field: 'created_at',
      sortable: true,
      cellRenderer: ({ value }) => value ? convertUtcToEst(value, { year: 'numeric', month: '2-digit', day: '2-digit' }) : '---'
    },
    {
      headerName: 'Actions',
      width: 150,
      pinned: 'right',
      sortable: false,
      cellRendererFramework: ({ node }) => {

        return (
          <div className="d-flex align-items-center table-icon table-icon-centered gap-3">
            <Tooltip title='Move to a location'>
              <span className="icon-print cursor-pointer" onClick={() => {
                setIsMoveToLocation(true);
                setSelectedIndex(node.rowIndex);
              }} ></span>
            </Tooltip>
            <Tooltip title='Inventory adjustment'>
              <img onClick={() => {
                setSelectedIndex(node.rowIndex);
                setShowInventoryAdjustmentModal(true);
              }} src={InventoryIcon} className="cursor-pointer" />
            </Tooltip>
            {/* <Tooltip title={'Delete'}>
              <BsTrash onClick={() => setDeleteLocation(true)} className={`cursor-pointer color-danger`} />
            </Tooltip> */}
            <Tooltip title='Product History'>
              <span
                className="icon-arrow-right cursor-pointer"
                onClick={() => {
                  setSelectedIndex(node.rowIndex);
                  setLocationHistory(true);
                }}
              ></span>
            </Tooltip>
          </div>
        );
      }
    }
  ], []);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetLocationProducts({
      id: locationId,
      params: {
        page: newPage,
        filters,
        sortBy,
        showZeroFlag: zeroEntriesSwitch
      }
    }));
  };

  const handleSearch = debounce(({ target }) => {
    const { value } = target || {};
    if (trim(value) || filters.search) {
      setFilters({ search: trim(value) });
      setPage(page => ({ ...page, pageNumber: 1 }));
      dispatch(GetLocationProducts({
        id: locationId,
        params: {
          page: { ...page, pageNumber: 1 },
          filters: { search: trim(value) },
          sortBy,
          showZeroFlag: zeroEntriesSwitch
        }
      }));
    }
  }, 800);

  const handleZeroEntriesSwitchChange = checked => {
    setZeroEntriesSwitch(checked);
    dispatch(GetLocationProducts({
      id: locationId,
      params: {
        page,
        filters,
        sortBy,
        showZeroFlag: checked
      }
    }));
  };

  const defaultColDef = {
    resizable: true,
    sortable: true
  };

  const refreshGridClick = () => {
    if (gridColumnApi){
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true
      });
      setSortBy({ key: '', type: '' });
    }
    dispatch(GetLocationProducts({
      id: locationId,
      params: {
        page,
        filters,
        showZeroFlag: zeroEntriesSwitch
      }
    }));
  };

  const handleExportToggle = (e)=>{
    setOpenExport(!openExport);
    e.stopPropagation();
  };

    const handleExportAll = ()=>{
      dispatch(GetLocationProducts({
        id: locationId,
        params: {
          exportAll: true,
          page,
          filters,
          showZeroFlag: zeroEntriesSwitch
        }
      })).then(({payload})=>{
        if(payload.success == true){
          handleExportLocationProducts(payload.exportedProducts);
        }
      });
    };

  const handleExportLocationProducts = (data) => {
    setOpenExport(false);
    let sortedSelectedRows;

    if (isArray(data)) {
        sortedSelectedRows = data;
         
    } else {
        const selectedRows = gridApi.getSelectedRows();
    
        if (selectedRows.length === 0) {
            notification.error({
                top: 65,
                message: 'Export Location Products',
                description: 'Please select at least one row to export.'
            });
            return;
        }
    
        sortedSelectedRows = sort(selectedRows, (item) => indexOf(locationProducts, item));
    }

    let locationName = '';
    const mappedData = sortedSelectedRows?.map((product) => {
      const {
        expiry_date,
        locations_v2,
        products_v2,
        quantity,
        created_at
      } = product || {};

      const { name } = locations_v2 || {};
      locationName = name || 'N/A';

      return {
        'Customer Name': products_v2?.user?.first_name || 'N/A',
        'Customer Email': products_v2?.user?.email || 'N/A',
        Title: products_v2?.name || 'N/A',
        'Image': products_v2?.image_url || 'N/A',
        identifier_type: products_v2?.identifier_type?.toUpperCase(),
        identifier_value: products_v2?.identifier_value || 'N/A',
        Brand: products_v2?.brand || 'N/A',
        Quantity : quantity || 0,
        // 'Reserved Quantity': product?.reserved_qty || 0,
        'Expiry Date': expiry_date ? convertUtcToEst(expiry_date, { month: 'long', day: '2-digit', year: 'numeric' }).replace(',', '').replace(/ /g, '/') : 'N/A',
        'Date Added': created_at ? convertUtcToEst(created_at, { month: 'long', day: '2-digit', year: 'numeric' }).replace(',', '').replace(/ /g, '/') : 'N/A',
        'Location Name' : locationName || 'N/A'
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PO Items');

    XLSX.writeFile(workbook, `${locationName} Products.xlsx`);
  };

    const SelectExportType = ()=>{
      return (
        <PoDetailsWrapper className='mt-0'>
          <div className='items-menu'>
            <span onClick={handleExportLocationProducts}>Export Selected</span>
            <span onClick={handleExportAll}>Export All</span>
          </div>
        </PoDetailsWrapper>
      );
    };

  const { id: productId } = locationProducts?.[selectedIndex]?.products_v2 || {};
  const locationProduct = locationProducts?.[selectedIndex]?.products_v2 || {};
  const { created_at, updated_at } = locationDetails || {};

  return (
    <WarehouseWrapper className="unassigned-location">
      <Spin size='large' tip="Processing..." spinning={fetchingLocationProducts}>
        <div className="name-details">
          <SearchInput
            placeholder="Search for Title/ Identifier"
            onChange={handleSearch}
          />
          <div className="label-wrapper-location">
            <div className="info">
              <span>Products:</span>
              <span>{totalLocationProductsCount || 0}</span>
            </div>
            <div className="info">
              <span>Created:</span>
              <span>
                {created_at
                  ? convertUtcToEst(created_at, {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                  })
                  : 'N/A'}
              </span>
            </div>
            <div className="info">
              <span>Updated:</span>
              <span>
                {updated_at
                  ? convertUtcToEst(updated_at, {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                  })
                  : 'N/A'}
              </span>
            </div>
          </div>
          <div className="last-section">
            <span className="switch-section">
              Enable Out of Stock Products
              <Switch defaultChecked={zeroEntriesSwitch} onChange={handleZeroEntriesSwitchChange} />
            </span>
            <Popover visible={openExport} overlayStyle={{ padding: 0 }} overlayClassName='dropdown-pop' trigger='click' Arrow={false} placement='bottom' title={null} content={<SelectExportType />}>
              <Spin size='small' spinning={false}>
                <Button
                  disabled={false}
                  onClick={handleExportToggle} startIcon={<GoUpload style={{ marginRight: '16px' }} />} endIcon={<IoIosArrowDown />} className="outlined" text="Export" />
              </Spin>
            </Popover>
          </div>
          
        </div>
        <div>
          <AgGrid
            gridReady={gridReady}
            user_referrals={locationProducts}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefinitions}
            onSortChange={onSortChange}
            rowHeight={55}
            height="190px"
            rowSelection='multiple'
          />

        </div>
        <Pagination
          total={totalLocationProductsCount}
          totalPages={ceil((totalLocationProductsCount / pageSize) + 1)}
          pageNumber={pageNumber}
          pageLimit={pageSize}
          handleLimitChange={(e) => handlePagination(e, 'pageSize')}
          handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
          handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
          handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
          refreshGridClick={refreshGridClick}
        />
      </Spin>

      {isMoveToLocation &&
        <MoveLocation
          isMoveToLocation={isMoveToLocation}
          setIsMoveToLocation={setIsMoveToLocation}
          selectedIndex={selectedIndex}
          refreshData={refreshGridClick}
          locationId={locationId}
        />
      }

      {showInventoryAdjustmentModal &&
        <InventoryAdjustment
          showInventoryAdjustmentModal={showInventoryAdjustmentModal}
          setShowInventoryAdjustmentModal={setShowInventoryAdjustmentModal}
          selectedIndex={selectedIndex}
          locationId={locationId}
          page={page}
          filters={filters}
          sortBy={sortBy}
          zeroEntriesSwitch={zeroEntriesSwitch}
        />
      }

      {locationHistory &&
        <LocationHistory
          locationHistory={locationHistory}
          setLocationHistory={setLocationHistory}
          productId={productId}
          locationProduct={locationProduct}
        />
      }

      <Modal
        open={deleteLocation}
        onHide={() => setDeleteLocation(false)}
        onClose={() => setDeleteLocation(false)}
        onSave={() => setDeleteLocation(false)}
        header={false}
        closeText="Cancel"
        saveText="Confirm"
        closeButton={true}
        removeIcon
        buttonDisabled={false}
        size="md"
        className="delete-confirmation-modal"
        centerAlign={false}
      >
        <WarehouseWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarnIcon} alt={WarnIcon} title={WarnIcon} className="color-danger" />
            <h3 className="mt-4">Warning</h3>
            <p>Are you sure you want to delete this Location?</p>
          </div>
        </WarehouseWrapper>
      </Modal>
    </WarehouseWrapper>
  );
};

export default Index;
